/* eslint no-multi-spaces: 0 */
/* eslint no-unused-vars : 0 */
/* eslint key-spacing    : 0 */

import Vue               from 'vue'
import axios             from 'axios'
import qs                from 'qs'
import {store}           from '@/components/store'

import env               from '@/core/api/env.json'
import endpoints         from '@/core/api/map.json'

import User              from '@/core/user'
import isMobileWebviewSession from '@/core/api/mobileWebview'
import legacyAuth        from '@/core/legacy-auth/index.vue'
import loadingIndicators from '@/core/loading-indicators'
import loginService      from '@/components/Login/loginService'

Vue.use(loadingIndicators)

const _HTML_ = 'text/html'
const _JS_   = 'application/javascript'
const _JSON_ = 'application/json'

const backend = (response) => {
  return {
    is: (type) => response.headers['content-type'] && response.headers['content-type'].indexOf(type) > -1,

    getError: (identifier) => {
      const el = document.createElement('html')
      const selector = identifier || '[style="color:maroon"]'

      el.innerHTML = response.data
      let query = el.querySelector(selector)
      return query ? query.innerHTML : ''
    }
  }
}

// Nothing strips ?token= from the route, so a deep-link token the server has already
// rejected would otherwise be retried on every request for the life of the session.
let staleUrlToken = null

const usableUrlToken = () => {
  const route = global.app && global.app.$router && global.app.$router.currentRoute
  const urlToken = route && route.query && route.query.token

  return urlToken && urlToken !== staleUrlToken ? urlToken : null
}

// Re-runs the handshake with the persisted token so loginService repopulates $user. Swapping
// the header alone leaves a cold-started webview authorised but user-less, and several
// EvedPay screens dereference $user.$ unguarded.
const retryWithPersistedToken = async (request, openApiToken) => {
  request.headers['Authorization'] = `Bearer ${openApiToken}`

  const r = await global.app.api.post('open-api/user/login', undefined, { usePersistedToken: true })

  if (r.data || r.data === '') {
    const moduleContext = document.querySelector('.theme.public').__vue__.$refs.currentModule
    await loginService.init.call(moduleContext, r.data, false, true)
  }
}

const Report = e => {
  // const url = error.request.responseURL.replace(process.env.NET_GATEWAY, '')
  // console.warn(`On ${new Date()}, ${global.app.$user.email} reported ${error} in ${url} from ${global.app.$route.path}`)
}

// Eved.Frontend env files are the canonical source for Platform hosts. Do not
// add qaproduction/sandbox/admin-team/reporting-team/workflow-team Platform
// hostnames here until Christi confirms they are valid for Eved.Web routing.
const platformEnvironmentMap = {
  'prod'                     : 'https://platform.eved.com/api',
  'production'               : 'https://platform.eved.com/api',
  'qa'                       : 'https://qa-platform.eved.com/api',
  'qainternaldemo'           : 'https://qa-platform.eved.com/api',
  'qainternaldemoevedonline.': 'https://qa-platform.eved.com/api',
  'qaproduction'             : 'https://qa-platform.eved.com/api',
  'qaproductionevedonline.'  : 'https://qa-platform.eved.com/api',
  'dev'                      : 'https://qa-platform.eved.com/api'
}

const platformGateway = (baseURL, environment) => {
  return platformEnvironmentMap[environment] || baseURL
}

export default {
  name   : 'Eved',
  getUser: User.$,

  install(Vue) {
    User.init()

    /** Set axios alias */
    Vue.prototype.$http = axios

    /** Set env api url */
    let environment = ''

    if (global.location.host === env.main) {
      environment = ''
    } else {
      environment = env[global.location.pathname.split('/')[1]] || env._default
    }
    // console.log('environment is', environment || env._default)

    let baseEnv = process.env.NET_GATEWAY
    let baseEnvL = process.env.PHP_GATEWAY
    let basePlatformEnv = platformGateway(process.env.PLATFORM_GATEWAY, environment)

    if (process.env.PORTAL_ENV && environment !== env._default) {
      baseEnv = baseEnv
        .replace(/https?/, 'https')
        .replace(env._default, `${environment}`)
      baseEnvL = baseEnvL
        .replace(/https?/, 'https')
        .replace(env._default, `${environment}`)
    } else {
      const envPrefix = process.env.PORTAL_ENV === false ? '' : env._default
      baseEnv = baseEnv.replace(env._default, `${envPrefix}${process.env.LEGACY_SUBDOMAIN}`)
      baseEnvL = baseEnvL.replace(env._default, `${envPrefix}${process.env.LEGACY_SUBDOMAIN}`)
    }

    /** Set api instance */
    var API = axios.create({
      baseURL: baseEnv,
      withCredentials: true,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    API.env = baseEnv.replace(env._default, environment)
    API._env = environment

    /**
     * Set instance for endpoints that require form data
     *
     */
    API.forms = axios.create({
      baseURL: baseEnv,
      headers: {
        'Content-Type'    : 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept'          : 'application/json, text/javascript, */*',
        'X-Requested-With': 'XMLHttpRequest'
      },
      data: {},
      withCredentials: true,
      timeout: 30000
    })

    API.platform = axios.create({
      baseURL: basePlatformEnv,
      withCredentials: true,
      headers: {
        'Accept'      : 'application/json',
        'Content-Type': 'application/json'
      }
    })
    API.platform.env = basePlatformEnv

    /** Intercept request payload and URL encode it */
    API.forms.interceptors.request.use(async request => {
      const openApiToken = localStorage.openApiToken
      const urlToken = usableUrlToken()
      if (
        urlToken
      ) {
        request.headers['Authorization'] = `Bearer ${urlToken}`
        try {
          const r = await global.app.api.post('open-api/user/login')
          if (r.data || r.data === '') {
            // Persisted before init, which awaits further requests that can fail on their
            // own. Losing the token there would send every later request back through the
            // handshake with nothing to fall back on.
            localStorage.openApiToken = urlToken
            let moduleContext = document.querySelector('.theme.public').__vue__.$refs.currentModule
            await loginService.init.call(moduleContext, r.data, false, true)
          } else {
            global.app.$user.$ = JSON.parse(localStorage.evedUser || '{}')
          }
        } catch (e) {
          // A stale deep-link token must not outrank a persisted one that still authorises.
          staleUrlToken = urlToken
          if (!openApiToken || openApiToken === urlToken) {
            throw e
          }
          await retryWithPersistedToken(request, openApiToken)
        }
      }

      // attach csrf
      request.headers['__RequestVerificationToken'] = store.state.isLoggedIn && store.state.csrf

      loadingIndicators.hook.start(request)

      request.data = qs.stringify(request.data)

      // proxy
      if (global.location.protocol === 'https:') {
        request.baseURL = process.env.NET_PROXY ? request.baseURL.replace(process.env.NET_GATEWAY, process.env.NET_PROXY) : request.baseURL
        request.baseURL = baseEnv.replace(env._default, environment)
      }

      return request
    })

    API.platform.interceptors.request.use(async request => {
      const currentRoute = global.app && global.app.$router && global.app.$router.currentRoute
      const urlToken = currentRoute && currentRoute.query && currentRoute.query.token

      if (urlToken) {
        request.headers['Authorization'] = `Bearer ${urlToken}`
      } else if (store.state.isLoggedIn && global.app.$user && global.app.$user.sessionSettings && global.app.$user.sessionSettings.Token) {
        request.headers['Authorization'] = `Bearer ${global.app.$user.sessionSettings.Token}`
      }

      if (request.baseURL && request.baseURL.match(/\/api\/?$/) && request.url && request.url.indexOf('api/') === 0) {
        request.url = request.url.replace(/^api\//, '')
      }

      loadingIndicators.hook.start(request)

      return request
    })

    API.platform.interceptors.response.use(response => {
      loadingIndicators.hook.stop(response)

      return response
    }, error => {
      setTimeout(() => { loadingIndicators.hook.stop(error) }, 100)

      return Promise.reject(error)
    })

    /**
     * Hook into api calls for handling loading indicators and notifications
     *
     */
    API.interceptors.request.use(async request => {
      const openApiToken = localStorage.openApiToken
      const urlToken = usableUrlToken()
      if (request.usePersistedToken && openApiToken) {
        request.headers['Authorization'] = `Bearer ${openApiToken}`
      } else if (
        urlToken
      ) {
        request.headers['Authorization'] = `Bearer ${urlToken}`
        const isAuthorizing = request.url === 'open-api/user/login'
        if (!isAuthorizing) {
          try {
            const r = await global.app.api.post('open-api/user/login')
            if (r.data || r.data === '') {
              // Persisted before init, which awaits further requests that can fail on their
              // own. Losing the token there would send every later request back through the
              // handshake with nothing to fall back on.
              localStorage.openApiToken = urlToken
              let moduleContext = document.querySelector('.theme.public').__vue__.$refs.currentModule
              await loginService.init.call(moduleContext, r.data, false, true)
            } else {
              global.app.$user.$ = JSON.parse(localStorage.evedUser || '{}')
            }
          } catch (e) {
            // A stale deep-link token must not outrank a persisted one that still authorises.
            staleUrlToken = urlToken
            if (!openApiToken || openApiToken === urlToken) {
              throw e
            }
            await retryWithPersistedToken(request, openApiToken)
          }
        }
      } else if (store.state.isLoggedIn && global.app.$user && global.app.$user.sessionSettings && global.app.$user.sessionSettings.Token) {
        request.headers['Authorization'] = `Bearer ${global.app.$user.sessionSettings.Token}`
      } else if (openApiToken) {
        // Mobile flow: after the urlToken handshake, the urlToken is persisted to
        // localStorage.openApiToken (above) but isLoggedIn/sessionSettings may not be
        // populated on subsequent internal navigations that drop the ?token= query.
        // Fall back to the persisted token so legacy JWT-validated controllers don't 500.
        request.headers['Authorization'] = `Bearer ${openApiToken}`
      }

      request.headers['__RequestVerificationToken'] = store.state.isLoggedIn && store.state.csrf

      if (request.url !== global.app.api.$.ping) {
        loadingIndicators.hook.start(request)
      }

      // proxy
      if (global.location.protocol === 'https:') {
        request.url = process.env.PHP_PROXY ? request.url.replace(process.env.PHP_GATEWAY, process.env.PHP_PROXY) : request.url
        request.url = process.env.NET_PROXY ? request.url.replace(process.env.NET_GATEWAY, process.env.NET_PROXY) : request.url
        request.url = request.url.replace(env._default, environment)
        request.baseURL = request.baseURL.replace(env._default, environment)
      }

      // map environment to other api environments
      if (~request.url.indexOf('http') && ~request.url.indexOf('api.')) {
        request.url = request.url.replace(
          '://',
          `://${environment.replace(process.env.LEGACY_SUBDOMAIN, '').replace(/\./g, '-')}`
        )
      }
      if (~request.url.indexOf('//') === 0 && ~request.url.indexOf('api.')) {
        request.url = `${global.location.protocol}${request.url.replace(request.baseURL, '')}`
      }

      if (~request.url.indexOf('{ENV}')) {
        request.url = request.url.replace(
          '{ENV}',
          global.app.api._env.replace(process.env.LEGACY_SUBDOMAIN, '').replace(/\./g, '-')
        )
      }

      return request
    })
    API.interceptors.response.use(response => {
      loadingIndicators.hook.stop(response)

      // Invalid session
      if (
        response.request.responseURL.indexOf(global.app.api.$.expired) > -1 &&
        response.request.responseURL.indexOf(
          encodeURIComponent('/Account/SignOutUser').replace(/%../g, m => m.toLowerCase())
        ) === -1
      ) {
        global.app.$user.logout()
        return response
      }

      /** If session expired */
      if (typeof response.data === 'string') {
        if (
          response.data.indexOf('session has expired') > -1 &&
          response.request.responseURL !== global.app.api.$.ping &&
          response.request.responseURL !== global.app.api.$.session &&
          // response.request.responseURL === global.app.api.$.expired &&
          response.request.responseURL !== global.app.api.$.login &&
          response.request.responseURL !== global.app.api.$.logout
        ) {
          if (global.app.$route.path === '/login') return response
          /* global.app.$notifications.notify({
            type: 'plain',
            icon: 'times-octagon',
            message: `${global.app.$t('Session Expired')}`,
            dismiss: global.app.$t('Login'),
            timeout: 0,
            placement: { from: 'top', align: 'center' },
            onClose: function (dismiss) {
              if (dismiss) {
                global.app.$user.logout()
              }
            }
          }) */
          global.app.$user.logout()

          return response
        }
      }

      /** If returned html, asume error */
      if (backend(response).is(_HTML_) && backend(response).getError()) {
        // Notification message
        global.app.$notifications.notify({
          type: 'warning',
          icon: 'times-octagon',
          message: backend(response).getError() +
            `<br><a href="#">Report this</a>`,
          timeout: 30000,
          placement: { from: 'bottom', align: 'right' }
        })
      }

      return response
    }, (error) => {
      /** Handle generic errors */
      // let target = error.response && error.response.config.url.replace(process.env.NET_GATEWAY, '').replace(/\//g, ' ')

      // Unauthorized
      if (error.response.status === 401) {
        // The mobile shell owns its own login, and a webview session recovers through the
        // persisted token on the next request. Tearing the session down here would strand it
        // on a page whose credentials it cannot submit, with $user and the back-history gone.
        if (!isMobileWebviewSession()) {
          global.app.$user.logout()
        }
        return Promise.reject(error)
      }

      const validationError = error.response &&
                              error.response.data.error &&
                              error.response.data.error.name &&
                              error.response.data.error.name === 'ValidationError'

      // EvedPay card endpoints send errors as a bare array ([{ Message }]), not { Errors: [...] } - read both (SPRT-18672)
      const errorData = error.response && error.response.data
      let errorMessage = (errorData && errorData.Errors && errorData.Errors[0] && errorData.Errors[0].Message) ||
                         (Array.isArray(errorData) && errorData[0] && errorData[0].Message) ||
                         'Something went wrong'
      if (error && !validationError && !JSON.parse(error.response.config.data || '{}').preventError) {
        // Notification message
        global.app.$notifications.notify({
          type: 'plain',
          icon: 'times-octagon',
          message:
            `Error
            <br><strong>${errorMessage}</strong>
            <br><a class="btn btn-xs btn-actionbar" target="_blank" href="https://www.eved.com/contact-us/">Report this</a>`,
          timeout: 0,
          placement: { from: 'top', align: 'center' }
        })
      }

      setTimeout(() => { loadingIndicators.hook.stop(error) }, 100)

      /** Handle server errors */
      if (error.response && error.response.status === 500) {
        // TODO: notify here
        return Promise.reject(error)
      } else {
        return Promise.reject(error)
      }
    })

    API.forms.interceptors.response = API.interceptors.response

    Vue.prototype.api = API
    Vue.prototype.api.$ = endpoints
    Vue.prototype.api.$.ping = baseEnvL + '/ping'
    Vue.prototype.api.$.login = '/Account/IdentityLogin'
    Vue.prototype.api.$.initLegacy = '/../api/v2/initLegacy'
    Vue.prototype.api.$.Login = '/Login/'
    Vue.prototype.api.$.logout = baseEnvL + '/signout'
    Vue.prototype.api.$.Logout = baseEnv + '/Account/SignOutUser'
    Vue.prototype.api.$.session = baseEnv + '/Sched/Welcome'
    Vue.prototype.api.$.expired = '/Account/IdentityLogin?ReturnUrl='
    Vue.prototype.api.$.privateResources = API.env + '/Storage/private/'

    Vue.component(legacyAuth.name, legacyAuth)
  }
}



// WEBPACK FOOTER //
// ./src/core/api/index.js